<script>
export default {
  emits: ['odjava', 'back'],
  data() {
    return {
      podatki: [],
    }
  },
  mounted() {
    this.ReadData();
  },
  methods: {
    ReadData() {
      axios.get('./api/log/dostopi/', {withCredentials: true}).then((response) => {
        this.podatki = response.data.podatki;
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$router.push('/Logout');
        }
      });
    }
  }
}
</script>
<template>
  <!-- 		<button class="p-2 btn-back" @click.prevent="$emit('back')"><i class="fas fa-arrow-left fa-2x"></i></button>
		<h5 class="d-flex justify-content-center text-white">Pregled dostopov v aplikacijo</h5> -->
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Pregled dostopov v aplikacijo</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 p-2">
    <div class="access-card">

      <div class="access-card-header">
        <div>
          <div class="access-title">Dostopi/vstopi v aplikacijo</div>
          <div class="access-subtitle">
            Pregled zadnjih prijav v aplikacijo
          </div>
        </div>
      </div>

      <div class="access-list">

        <div class="access-row access-row-header">
          <div>E-naslov</div>
          <div>IP naslov</div>
          <div>Zadnji dostop</div>
        </div>

        <div
            class="access-row"
            v-for="dostop in podatki"
            :key="dostop.email + dostop.ip"
        >
          <div class="access-user">
            <div class="access-icon">👤</div>
            <div class="text-truncate">
              {{ dostop.email }}
            </div>
          </div>

          <div>
          <span class="access-ip">
            {{ dostop.ip }}
          </span>
          </div>

          <div class="access-date">
            {{ dostop.zadnji_dostop }}
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ODMIK OD FOOTERJA -->
  <div class='w-100 mt-5'></div>
</template>
<style>
.access-card {
  background: #151922;
  border: 1px solid #2a303d;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, .18);
}

.access-card-header {
  padding: 20px 22px;
  border-bottom: 1px solid #2a303d;
}

.access-title {
  color: #fff;
  font-size: 1.15rem;
  font-weight: 600;
}

.access-subtitle {
  color: #7f8898;
  font-size: .85rem;
  margin-top: 4px;
}

.access-list {
  width: 100%;
}

.access-row {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  align-items: center;
  gap: 20px;
  padding: 14px 22px;
  color: #dce1e8;
  border-bottom: 1px solid #252b36;
  transition: background .2s ease;
}

.access-row:last-child {
  border-bottom: 0;
}

.access-row:not(.access-row-header):hover {
  background: #1c222d;
}

.access-row-header {
  color: #737d8d;
  font-size: .75rem;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.access-user {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.access-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #242b38;
  border-radius: 50%;
}

.access-ip {
  display: inline-block;
  padding: 4px 9px;
  border-radius: 6px;
  background: #222936;
  color: #aeb8c7;
  font-family: monospace;
  font-size: .85rem;
}

.access-date {
  color: #aeb5c0;
  font-size: .9rem;
}

@media (max-width: 768px) {
  .access-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .access-row-header {
    display: none;
  }

  .access-row {
    padding: 16px;
  }
}

</style>